import {
  ADD_PRODUCT,
  ADD_OPEN_VALUE_PRODUCT,
  REMOVE_PRODUCT,
  EMPTY_BASKET,
  UPDATE_LOCATION,
  UPDATE_STOCK
} from "../actions/Product"
import * as product from "../helpers/product/basket"

const newInitialState = {
  basket: {},
  cinemaLocation: "",
  stock: {}
}
const Product = (state = newInitialState, action) => {
  switch (action.type) {
    case ADD_PRODUCT:
      return {...state, basket: product.addToBasket(state.basket, action.uuid)}
    case ADD_OPEN_VALUE_PRODUCT:
      return {...state, basket: product.addOpenValueToBasket(state.basket, action.uuid, action.value)}
    case REMOVE_PRODUCT:
      return {...state, basket: product.removeFromBasket(state.basket, action.uuid)}
    case EMPTY_BASKET:
      return {...state, basket: {}, location: ""}
    case UPDATE_LOCATION:
      return {...state, cinemaLocation: action.cinemaLocation}
    case UPDATE_STOCK:
      return {...state, stock: action.stock}
    default:
      return state
  }
}

export default Product
